import { StoreState } from '@/core/models/store.interface';
import { LocationQuery } from 'vue-router';
import { Module } from 'vuex';
import { JobType } from './job-type.interface';
import { JobTypeService } from './job-type.service';

const service = new JobTypeService();

export interface JobTypeState {
   jobTypes: Array<JobType>;
}

const JobTypeStore: Module<JobTypeState, StoreState> = {
   namespaced: true,
   state: {
      jobTypes: [],
   },
   getters: { jobTypes: (state) => state.jobTypes },
   mutations: {
      SET_JOB_TYPES(state, jobTypes: Array<JobType>) {
         state.jobTypes = jobTypes;
      },
   },
   actions: {
      async getJobTypes(context, query: LocationQuery) {
         const response = await service.getJobTypes({ ...query });
         context.commit('SET_JOB_TYPES', response.data);
         return response;
      },
   },
};

export default JobTypeStore;
